import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Briefcase, Calculator, Sparkles, Rocket } from "lucide-react";
import JobRolesPage from "./JobRolesPage";
import JobPlansPage from "./JobPlansPage";

export default function CargosSalariosPage() {
  const [tab, setTab] = useState("cargos");
  return (
    <div className="space-y-5" data-testid="cargos-salarios-page">
      <div className="rounded-2xl bg-gradient-to-br from-[#234935] to-[#0F1C14] text-white p-6 md:p-8 relative overflow-hidden">
        <div className="absolute -top-12 -right-8 h-48 w-48 rounded-full bg-[#C5A059]/20 blur-[60px]" />
        <div className="relative">
          <div className="text-[10.5px] uppercase tracking-[0.24em] text-[#C5A059] font-medium flex items-center gap-2">
            <Rocket className="h-3.5 w-3.5" /> Gestão estratégica de carreira
          </div>
          <h1 className="font-display text-3xl md:text-[36px] font-semibold mt-2 leading-tight">
            Cargos <span className="text-[#C5A059]">&</span> Salários
          </h1>
          <p className="mt-3 max-w-[720px] text-[13.5px] text-white/75 leading-relaxed">
            Administre a estrutura de cargos com requisitos, critérios de promoção e atividades.
            Gere tabelas salariais a partir de função-base e publique cargos individuais editáveis.
          </p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-white border border-border p-1 h-auto">
          <TabsTrigger value="cargos" data-testid="cs-tab-cargos" className="gap-2 data-[state=active]:bg-[#234935] data-[state=active]:text-white px-4 py-2">
            <Briefcase className="h-4 w-4" /> Cargos detalhados
          </TabsTrigger>
          <TabsTrigger value="tabela" data-testid="cs-tab-tabela" className="gap-2 data-[state=active]:bg-[#234935] data-[state=active]:text-white px-4 py-2">
            <Calculator className="h-4 w-4" /> Tabela salarial (planos)
          </TabsTrigger>
        </TabsList>

        <TabsContent value="cargos" className="mt-4">
          <JobRolesPage />
        </TabsContent>

        <TabsContent value="tabela" className="mt-4">
          <div className="rounded-md border border-[#E8D9AE] bg-[#F9F4E7] px-4 py-3 text-[12.5px] text-[#5C4320] flex items-start gap-2 mb-4">
            <Sparkles className="h-4 w-4 mt-0.5 text-[#8A6B2B] shrink-0" />
            <span>
              <b>Dica:</b> use esta aba para gerar automaticamente a estrutura salarial
              a partir de um cargo-base (ex.: "Analista" → Auxiliar, Trainee, Júnior, Pleno, Sênior).
              Depois clique em <b>Publicar cargos</b> para transformar cada nível em um cargo
              individual editável na aba <b>Cargos detalhados</b>.
            </span>
          </div>
          <JobPlansPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
